<app-headline-page>
    {{ block.locationIndependent ? ('cancel_independent_phonenumber_order_complete_headline' | i18next) :
    'cancel_phonenumber_order_complete_headline' | i18next }}
</app-headline-page>

<app-card>
    @if (block.locationIndependent) {
        <app-fa-icon class="d-flex mb-3 mx-auto" icon="fa-check" size="3xl"></app-fa-icon>
    } @else {
        <app-fa-icon class="d-flex mb-3 mx-auto" icon="fa-calendar" size="3xl"></app-fa-icon>
    }
    
    <app-headline-content class="d-flex mx-auto">
        {{ block.locationIndependent ? ('cancel_independent_phonenumber_order_complete_headline' | i18next) :
        'cancel_phonenumber_order_complete_headline' | i18next }}!
    </app-headline-content>

    <div class="d-flex mx-auto" [innerHTML]="block.locationIndependent ? ('endcustomer_cancel_independent_phonenumber_order_complete_content' | i18next) :
        'endcustomer_cancel_phonenumber_order_complete_content' | i18next"></div>
</app-card>

<div class="d-flex justify-content-end mt-3">
    <button class="btn btn-outline-primary" (click)="next.emit()">
        {{ 'back_subscription_details' | i18next }}
    </button>
</div>